import React from 'react';
import { FaTimes } from 'react-icons/fa'; // Close icon
import CustomButton from './CustomButton';
import Typography from './Typography';

const CustomModal = ({ type = 'success', title, message, onClose, onConfirm, colseText, confirmButton = true, closeButton = false }) => {
    const backgroundSVG = (
        // <svg xmlns="http://www.w3.org/2000/svg" width="661" height="404" viewBox="0 0 661 404" fill="none">
        //     <path d="M0 53.5L58.5 0H661V404H0V53.5Z" fill="#1B1B1B" />
        // </svg>
        <img
            src={require('../images/Rectangle 4488.png')}
            alt="support"
            className='w-full h-full'
            style={{ objectFit: 'cover' }}
        />
    );

    const successIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="93" height="92" viewBox="0 0 93 92" fill="none">
            <path d="M32.9831 13.6305L60.193 13.3985L79.2382 32.115L78.9624 58.8162L59.5271 77.8608L32.3172 78.0929L13.272 59.3764L13.5478 32.6752L32.9831 13.6305Z" fill="#DF0F11" />
            <mask id="mask0" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="26" y="26" width="40" height="40">
                <rect x="26" y="26" width="40" height="40" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0)">
                <path d="M41.9168 57.334L31.0835 46.5007L34.8335 42.7507L41.9168 49.834L57.1668 34.584L60.9168 38.334L41.9168 57.334Z" fill="#1C1B1F" />
            </g>
        </svg>
    );

    const errorIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" viewBox="0 0 86 86" fill="none">
            <mask id="mask0_1797_8201" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="86">
                <rect width="86" height="86" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1797_8201)">
                <path d="M43 60.9167C44.0153 60.9167 44.8663 60.5733 45.5531 59.8865C46.2399 59.1997 46.5833 58.3486 46.5833 57.3333C46.5833 56.3181 46.2399 55.467 45.5531 54.7802C44.8663 54.0934 44.0153 53.75 43 53.75C41.9847 53.75 41.1337 54.0934 40.4469 54.7802C39.7601 55.467 39.4167 56.3181 39.4167 57.3333C39.4167 58.3486 39.7601 59.1997 40.4469 59.8865C41.1337 60.5733 41.9847 60.9167 43 60.9167ZM39.4167 46.5833H46.5833V25.0833H39.4167V46.5833ZM29.5625 75.25L10.75 56.4375V29.5625L29.5625 10.75H56.4375L75.25 29.5625V56.4375L56.4375 75.25H29.5625Z" fill="#DF0F11" />
            </g>
        </svg>
    );

    const questionIcon = (
        <div className='relative h-[92px] w-[93px] flex items-center justify-center'>
            <svg xmlns="http://www.w3.org/2000/svg" width="93" height="92" viewBox="0 0 93 92" fill="none" className='absolute top-0 left-0'>
                <path d="M32.9831 13.6308L60.193 13.3988L79.2382 32.1153L78.9624 58.8164L59.5271 77.8611L32.3172 78.0931L13.272 59.3766L13.5478 32.6754L32.9831 13.6308Z" fill="#DF0F11" />
            </svg>
            <div className='h-[30px] w-[19px]'>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="30" viewBox="0 0 19 30" fill="none" className='relative z-20 h-full w-full'>
                    <path d="M7.34091 20.4429V15.3857L14.6818 10.8V7.71429C14.6818 5.78572 13.1705 4.28572 11.2273 4.28572H7.77273C5.87273 4.28572 4.31818 5.82857 4.31818 7.71429V9.21429H0V7.71429C0 3.42857 3.49773 0 7.77273 0H11.2273C15.5455 0 19 3.42857 19 7.71429V13.1571L11.6591 17.7429V20.4429H7.34091ZM7.125 25.7143H11.875V30H7.125V25.7143Z" fill="#1B1B1B" />
                </svg>
            </div>
        </div>
    )

    const loadingIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" className='animate-spin -ml-1 mr-3' width="62" height="62" viewBox="0 0 62 62" fill="none">
            <path d="M21.5944 56.8415L19.378 55.9234L17.25 54.8156L15.2266 53.5266L13.3233 52.0662L11.5546 50.4454L9.93378 48.6766L8.47332 46.7733L7.1843 44.7499L6.07654 42.6219L5.15845 40.4055L4.43704 38.1175L3.91779 35.7753L3.60465 33.3967L3.5 30.9999L3.60465 28.6032L3.91779 26.2246L4.43704 23.8824L5.15845 21.5944L6.07654 19.3779L7.1843 17.2499L8.47332 15.2266L9.93378 13.3233L11.5546 11.5545L13.3233 9.93372L15.2266 8.47326L17.25 7.18424L19.378 6.07648L21.5944 5.15839L23.8825 4.43698L26.2247 3.91772" stroke="#333333" strokeWidth="6" strokeLinecap="round" />
            <path d="M35.7753 3.91772L38.1175 4.43698L40.4056 5.15839L42.622 6.07647L44.75 7.18424L46.7734 8.47326L48.6767 9.93372L50.4454 11.5545L52.0662 13.3233L53.5267 15.2266L54.8157 17.2499L55.9235 19.3779L56.8415 21.5944L57.563 23.8824L58.0822 26.2246L58.3954 28.6032L58.5 30.9999L58.3954 33.3967L58.0822 35.7753L57.563 38.1175L56.8415 40.4055L55.9235 42.6219L54.8157 44.7499L53.5267 46.7733L52.0662 48.6766L50.4454 50.4454L48.6767 52.0662L46.7734 53.5266L44.75 54.8156L42.622 55.9234L40.4056 56.8415L38.1175 57.5629L35.7753 58.0822L33.3968 58.3953L31 58.4999" stroke="#DF0F11" strokeWidth="6" strokeLinecap="round" />
        </svg>
    );

    return (
        <div data-modal-title={title} className="fixed fade inset-0 z-50 flex items-center h-full justify-center bg-black bg-opacity-60 transition-all animate-backdropFadeIn">
            <div className="relative w-[661px] sm:block hidden mx-3 animate-modalSlideIn">
                {backgroundSVG}
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center p-9">
                    {/* Close Icon */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-6 text-white text-lg hover:text-gray-300"
                        aria-label="Close modal"
                    >
                        <FaTimes size={20} />
                    </button>

                    <div className="mb-[28.51px] : mt-[17px]">
                        {type === 'success' && successIcon}
                        {(type === 'error' || type === 'confirm') && errorIcon}
                        {type === 'question' && questionIcon}
                        {type === 'loading' && loadingIcon}
                    </div>
                    {/* <h2 className=" font-bold">{title}</h2> */}
                    <Typography text={title} transform={'uppercase'} family={'Supply'} size={'36px'} />
                    <Typography text={message} className='mt-8 w-[349px]' opacity={0.6} color={'#FFF'} size={'18px'} />
                    {confirmButton && <CustomButton onClick={onConfirm ? onConfirm : onClose} className='mt-10' text={colseText ? colseText : type === 'success' ? 'Okay' : 'Try Again'} />}
                </div>
            </div>
            <div className="relative sm:hidden block mx-3 animate-modalSlideIn">
                <svg xmlns="http://www.w3.org/2000/svg" width="331" height="355" viewBox="0 0 331 355" fill="none">
                    <path d="M0 53.5L58.5 0H330.5V355H0V53.5Z" fill="#1B1B1B" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center p-5">
                    {/* Close Icon */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-6 text-white text-lg hover:text-gray-300"
                        aria-label="Close modal"
                    >
                        <FaTimes size={20} />
                    </button>

                    <div className="mb-[20.51px] : mt-[17px]">
                        {type === 'success' && successIcon}
                        {(type === 'error' || type === 'confirm') && errorIcon}
                        {type === 'question' && questionIcon}
                        {type === 'loading' && loadingIcon}
                    </div>
                    {/* <h2 className=" font-bold">{title}</h2> */}
                    <Typography text={title} transform={'uppercase'} family={'Supply'} size={'28px'} />
                    <Typography text={message} className='mt-8' opacity={0.6} color={'#FFF'} size={'12px'} />
                    {confirmButton && <CustomButton onClick={onConfirm ? onConfirm : onClose} className='mt-10' text={colseText ? colseText : type === 'success' ? 'Okay' : 'Try Again'} />}
                    {closeButton && <CustomButton onClick={onClose} className='mt-10' text={'Cancel'} />}
                </div>
            </div>
        </div>
    );
};

export default CustomModal;
